/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Snackbar, SnackbarCloseReason } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { AutoCompleteContaBancaria, AutoCompleteVerbas, IVFormErrors, useVForm, VFieldMoney, VForm, VTextField } from '../../../shared/forms';
import * as yup from 'yup';
import { v4 as uuidv4 } from 'uuid';
import { VerbaService } from '../../../shared/services/api/rh/verbas/VerbaService';
import { DialogFeriasAlterar } from '../colaborador/DialogFeraisAlterar';
import { ChequeEmitidosService } from '../../../shared/services/api/Financeiro/ChequeEmitidos';

interface IFormData {
  idconta: number;
  inicial: number;
}

interface IFormDataCh {
  nome: string;
  valor: number;
}

export interface ConfirmationDialogRawProps {
  id: string;
  value: string;
  open: boolean;
  dados?: IFormDataCh[];
  onClose: (value?: string) => void;
}

const formValidationSchema: yup.ObjectSchema<IFormData> = yup.object().shape({
  idconta: yup.number().required(),
  inicial: yup.number().required(),
});

export const DialogCheque: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {
  const {formRef, save, } = useVForm();
  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
        
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }        
    setOpenmsg(false);   
  };

  const guuid = uuidv4();

  const handleCancel = () => {
    onClose();
  };

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }else{
      setId(valueProp);
    }
  }, [valueProp, open]);
  
  const handleSave = (dados: IFormData) => {
    setIsLoading(true);  
    formValidationSchema.
      validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        const listch =  props.dados?.map((listItem, index) => {
          const n = dadosValidados.inicial + index;
          return {
            idcheque: uuidv4(),
            datadeposito: new Date(), 
            emissao: new Date(),
            idconta: dadosValidados.idconta,
            credor:  listItem.nome,
            valor: listItem.valor,
            contapagas: false,
            numero: n.toString(),
            historico: 'Folha de Pagamento',
            status: 1,
          };           
        }) || [];

        ChequeEmitidosService
          .GeraCheque(listch)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setTms('success');
              setMsg('Lançamento Realizado com sucesso!');
              setOpenmsg(true);
            }
          });

      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};   
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  return (
    <Dialog
      open={open}
      {...other}      
    >
      <DialogTitle>Dialogo Cheque</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef}  onSubmit={handleSave}>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
            <Alert
              onClose={handleCloseMsg}
              severity={tms}
              variant="filled"
              sx={{ width: '100%' }}
            > 
              {msg}
            </Alert>
          </Snackbar>
          <Grid container direction="column" padding={1}>
            <Grid container item direction="row" padding={1} spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                <Grid container item direction="row" spacing={1} >
                  <Grid item xs={12} sm={12} md={9} lg={8} xl={8}>
                    <AutoCompleteContaBancaria
                      name='idconta'
                      label='Conta Bancaria'
                    />   
                  </Grid> 
                  <Grid item xs={12} sm={12} md={2} lg={4} xl={4}>
                    <VTextField
                      type='number'
                      fullWidth
                      size='small'
                      name='inicial'
                      label='Numero Inicial'
                    />
                  </Grid>   
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </VForm>
      </DialogContent>
      <DialogActions>
        <Button size='small' variant='outlined' onClick={handleCancel}>Voltar</Button>      
        <Button size='small' variant='outlined' autoFocus onClick={save}>Confirmar</Button>
      </DialogActions>
    </Dialog>
    
  );
}; 